// Lib
import React, { ReactElement } from 'react';

// Styles
import './AiModeHeaderSection.scss';

interface AiModeHeaderSectionProps {
    children: ReactElement | Array<ReactElement | null>;
}

const AiModeHeaderSection = (props: AiModeHeaderSectionProps): ReactElement => {
    const { children } = props;

    return <div className="AiModeHeaderSection">{children}</div>;
};

export default AiModeHeaderSection;
